import React, { useContext } from 'react';
import { ClientInvitation } from '../../../../../hooks/api/useMyOrganizationClientInvitations';
import { BaseLogCard } from '../../../../shared/LogList/LogCard';
import { LoadableAvatar, getFallbackForGenericString } from '../../../../v2BaseComponents/Avatar';
import urls from '../../../../../utils/urls';
import { getIntl } from '../../../../../utils/intl';
import getName from '../../../../../utils/getName';
import { RePromptOrganizationInvitationContext } from '../../../../shared/OrganizationInvitationGate';

const intl = getIntl('pending-organization-client-invitation-log-card', {
    pendingOrganizationClientInvitation: 'Pending Organization Client Invitation',
    content: "You have an invitation from {organizationName} to help manage {profileName}'s Medical Profile",
});

export type PendingOrganizationClientInvitationLogCardOwnProps = {
    clientInvitation: ClientInvitation;
};

export type PendingOrganizationClientInvitationLogCardProps = PendingOrganizationClientInvitationLogCardOwnProps;

const PendingOrganizationClientInvitationLogCard: React.FC<PendingOrganizationClientInvitationLogCardProps> = (
    props,
) => {
    const rePromptInvitation = useContext(RePromptOrganizationInvitationContext);
    const avatar = (
        <LoadableAvatar
            size="sm"
            fallbackName={getFallbackForGenericString(props.clientInvitation.organization.metadata.name)}
            avatarUrl={urls.api.organizations.clientInvitations.invitationOrganizationAvatar(
                props.clientInvitation.organization.organizationId,
                props.clientInvitation.organizationClientInvitationId,
            )}
        />
    );
    const content = intl('content', {
        organizationName: props.clientInvitation.organization.metadata.name,
        profileName: getName({
            firstName: props.clientInvitation.clientFirstName,
            lastName: props.clientInvitation.clientLastName,
        }),
    });
    return (
        <BaseLogCard
            avatar={avatar}
            headerText={intl('pendingOrganizationClientInvitation')}
            logMessage={content}
            onPress={rePromptInvitation}
            testID="pending-client-invitation-log-card"
        />
    );
};

export default React.memo(PendingOrganizationClientInvitationLogCard);
